
var define, require;
(function () {
    var map = {};

    function arrayMap(arr, cb) {
        if (Array.prototype.map) return arr.map(cb);

        var newArr = [];
        if (typeof (cb) !== 'function') throw new TypeError();

        for (var i = 0; i < arr.length; i++) {
            newArr.push(cb.call(null, arr[i], i, arr));
        }
        return newArr;
    }

    function inArray(arr, e) {
        for (var i = 0; i < arr.length; i += 1) {
            if (arr[i] === e) return i;
        }
        return -1;
    }

    function resolvePath(current, path) {
        if (!(/^\.\.?\//).test(path)) return path; // Not a relative path

        var currentParts = current.split("/"),
            parts = currentParts.slice(0, currentParts.length - 1).concat(path.split("/")),
            stack= [];

        for (var i = 0; i < parts.length; i += 1) {
            if (parts[i] === '.') {
                // Do nothing
            } else if (parts[i] === '..') {
                stack.pop();
            } else {
                stack.push(parts[i]);
            }
        }
        return stack.join("/");
    }

    function cjsRequire(current) {
        return function (id) {
            return loadMod(id, current);
        };
    }

    function loadDeps(deps, current, depth) {
        return arrayMap(deps, function (m) {
            if (m === 'require') {
                return cjsRequire(current);
            } else if (m === 'exports') {
                return map[current].module.exports;
            } else if (m === 'module') {
                return map[current].module;
            }
            return loadMod(m, current);
        });
    }

    function loadMod(id, curr, depth) {
        if (curr) id = resolvePath(curr, id);
        if (!depth) depth = [];

        var modInfo = map[id];

        if (!modInfo || !modInfo.factory) {
            throw "Error loading mod '" + id + "' from '" + curr + "'.";
        }
        if (inArray(depth, id) !== -1) {
            throw "No circular dependancies. '" + id + "' from '" + curr + "'";
        }
        depth.push(id);

        if (!modInfo.loaded) {
            modInfo.module.exports = {};
            var deps = modInfo.deps && loadDeps(modInfo.deps, id, depth);
            modInfo.module.exports = modInfo.factory.apply(null, deps);
            modInfo.loaded = true;
        }

        return modInfo.module.exports;
    }

    define = function (id, dependencies, factory) {
        if (typeof (id) !== 'string') throw new Error("Modules must be names with a string. '" + id + "' from '" + curr + "'");

        if (Object.prototype.toString.call(dependencies) !== '[object Array]') {
            factory = dependencies;
            dependencies = ['require', 'exports', 'module'];
        }

        map[id] = {
            id: id,
            deps: dependencies,
            factory: factory
        };
        map[id].module = {
            id: id,
            exports: map[id].exports
        };
    };
    define.amd = {};
    require = function (dependencies, factory) {
        if (typeof (dependencies) === 'string') {
            // Return single module
            return loadMod(dependencies);
        } else {
            if (Object.prototype.toString.call(dependencies) !== '[object Array]') {
                factory = dependencies;
                dependencies = [];
            }
            dependencies = loadDeps(dependencies);
            if (typeof (factory) === 'function') {
                factory.apply(null, dependencies);
            }
        }
    };
}());
